// Proposals, Invoices and POs can carry an optional name ("Living Room") next
// to their number. The number stays the identifier — it syncs to QuickBooks and
// never repeats — so the name is always shown alongside it, never instead of it.

export const DOCUMENT_TITLE_MAX_LENGTH = 120;

export function documentLabel(number, title) {
  const num = String(number || '').trim();
  const name = String(title || '').trim();
  if (num && name) return `${num} · ${name}`;
  return num || name;
}
